export class ProgramType {
    public static readonly Program = new ProgramType(1);
    public static readonly Tournament = new ProgramType(2);
    public static readonly Trial_Tryout = new ProgramType(3);
    public static readonly Club_Reservation = new ProgramType(4);
    private constructor(public readonly value: number) {}


    private static readonly translations: Record<number, { en: string; ar: string }> = {
        1: { en: 'Program', ar: 'برنامج' },
        2: { en: 'Tournament', ar: 'بطولة' },
        3: { en: 'Trial & Tryout ', ar: 'معايشة او اختبار' },
        4: { en: 'Club Reservation', ar: 'تسجيل في نادي' }
    };

    // Get label based on current language
    public label(lang: 'en' | 'ar' = 'en'): string {
        return ProgramType.translations[this.value][lang];
    }

    public static values(): ProgramType[] {
        return [
            ProgramType.Program,
            ProgramType.Tournament,
            ProgramType.Trial_Tryout,
            ProgramType.Club_Reservation
        ];
    }



    // Get options for dropdowns
    public static getOptions(lang: 'en' | 'ar' = 'en'): Array<{value: number, label: string}> {
        return ProgramType.values().map(item => ({
            value: item.value,
            label: item.label(lang)
        }));
    }
	static getValueByLabel(label: string): number {
		if (!label) {
			return ProgramType.Program.value; // Default fallback
		}

		// Map of exact label strings to ProgramType instances
		const labelMap: Record<string, ProgramType> = {
			Program: ProgramType.Program,
			Tournament: ProgramType.Tournament,
			Trial_Tryout: ProgramType.Trial_Tryout,
			Club_Reservation: ProgramType.Club_Reservation,
		};

		const match = labelMap[label];
		return match ? match.value : ProgramType.Program.value;
	}



}
